import { ComponentProps } from "react";

import { Logo } from "@design-system/Logo/Logo";

import { isDomain } from "@utils/isDomain";

type Props = {
  signedLogoUrl?: string;
  domain?: string;
  size?: ComponentProps<typeof Logo>["size"];
};

export const CompanyLogo = ({ domain, signedLogoUrl, size }: Props) => {
  return (
    <Logo
      src={
        signedLogoUrl ||
        (domain && isDomain(domain)
          ? `https://cdn.brandfetch.io/${domain}/icon/w/400/h/400/fallback/lettermark?c=1idvlF0AmH9Y1_AzHBh`
          : `https://cdn.brandfetch.io/fallbackcompany.com/fallback/lettermark?c=1idvlF0AmH9Y1_AzHBh`)
      }
      size={size}
    />
  );
};
